const hideElement = (element) => element.classList.add('hidden');
const showElement = (element) => element.classList.remove('hidden');

export{ hideElement, showElement };